module.exports = __webpack_public_path__ + "img/Map.22cab898.png";